import React, { useState, useEffect } from 'react';
import { InputAutocomplete, InputAutocompleteBtn, InputAutocompleteArray } from './Inputs'
import { getApi, getApiSetLocalStorage, getUsuario } from '../util/Configuracoes'
import { ModalPadraoCadastroCentral } from './Modais'
import { CadastroPaciente } from '../areas/atendimento/beneficiario/pages/Cadastro'
import ls from 'local-storage'
import { get } from '../util/AcessoApi'
import { removeAcentos } from '../util/FuncoesComuns'
import { useFormikContext } from "formik"
import 'moment/locale/pt-br'
import { components } from 'react-select'

const InputPorArray = (props) => {
    const [data, setData] = useState(new Promise((resolve, reject) => resolve(props.data)))

    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(data).then(value => filtrar(value, inputValue))

    return (
        <InputAutocompleteArray
            isClearable={props.isClearable != undefined ? props.isClearable : true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo != undefined ? props.multiplo : false}
            placeholder={props.placeholder}
            obrigatorio={props.obrigatorio}
            onChange={props.onChange}
            loadOptions={promiseOptions}
            {...props}
        />
    )
}

const InputMunicipioFiltro = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrarMunicipios = inputValue => {
        let dataMunicipio = ls.get('dataMunicipio')
        if (dataMunicipio) {
            return dataMunicipio.filter(i =>
                removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase()))
            ).slice(0, 10)
        }
    }

    const carregarMunicipios = async (inputValue, callback) => {
        let dataMunicipio = ls.get('dataMunicipio')

        if (!dataMunicipio) {
            dataMunicipio = await getApiSetLocalStorage('dataMunicipio', '/parametros/municipioCombo')
        }

        if (inputValue.toString().length > 0)
            return callback(filtrarMunicipios(inputValue))

        return dataMunicipio.slice(0, 10)
    }

    const defaultValue = props.colunaFiltros ? props.colunaFiltros.valor : null


    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            placeholder={props.placeholder}
            obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={carregarMunicipios}

            isMulti={true}
            value={values[props.name] || defaultValue}

            {...props} />)
}

const InputOperadoraSaude = props => {
    const { setFieldValue, values } = useFormikContext(); // aqui
    let removerInativos = props.removerInativos || false
    const [showModal, setShowModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))
    const promiseOptions = inputValue => Promise.resolve(get('/administracao/operadoraSaudeCombo', { removerInativos }, null, null)).then(value => filtrar(value, inputValue))
    const [data, setData] = useState([])


    useEffect(() => {
        if (itemSelecionado != null) {
            getApi(setData, '/administracao/operadoraSaudeCombo')
            if (props.multiplo) {
                const array = values[props.name] || []
                array.push(itemSelecionado)
                setFieldValue(props.name, [...array])
            } else
                setFieldValue(props.name, itemSelecionado)
        }
    }, [itemSelecionado, props.multiplo, props.name, setFieldValue, values])

    const action = _ => { setShowModal(true) }

    return (
        <>
            <InputAutocompleteBtn
                isClearable={true}
                tamanho={props.tamanho}
                label={props.label}
                name={props.name}
                type="select"
                action={() => action()}
                isMulti={props.multiplo || false}
                placeholder={props.placeholder || props.label} obrigatorio={props.obrigatorio}
                onChange={option => setFieldValue(props.name, option) &&
                    (props.functionOnChange && props.functionOnChange(props.propsFormik, option) || '')}
                loadOptions={promiseOptions}

                defaultOptions={data.length > 0 ? data : true}
                {...props} />
            {/* <ModalPadraoCadastro titulo={'Cadastro Operadora de Saúde'} showModal={showModal} setShowModal={setShowModal}>
                <CadastroOperadoraSaude modal="true" setShow={setShowModal} setItemSelecionado={setItemSelecionado} {...props} />
            </ModalPadraoCadastro> */}
        </>
    )
}

const InputTipoEndereco = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/tipoEnderecoCombo', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputSimNao = (props) => {
    const data = [{ value: 'true', label: 'Sim' },
    { value: 'false', label: 'Não' }]

    const filtrar = inputValue =>
        data && data.filter(i =>
            removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase()))
        ).slice(0, 10);

    const loadOptions = (inputValue, callback) => callback(filtrar(inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            obrigatorio={props.obrigatorio}
            onChange={option => { props.propsFormik.setFieldValue(props.name, option); props.onChangeValue && props.onChangeValue(option) }}
            loadOptions={loadOptions}
            propsFormik={props.propsFormik}
            {...props} />
    )
}

const InputGrupo = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const [showModal, setShowModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)
    const [data, setData] = useState([])

    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/controleAcesso/grupoCombo', null, null, props.noAuth)).then(value => filtrar(value, inputValue))

    useEffect(() => {
        if (itemSelecionado != null) {
            getApi(setData, '/controleAcesso/grupoCombo', null, null, props.noAuth)
            if (props.multiplo) {
                const array = values[props.name] || []
                array.push(itemSelecionado)
                setFieldValue(props.name, [...array])
            } else
                setFieldValue(props.name, itemSelecionado)
        }
    }, [itemSelecionado, props.multiplo, props.name, props.noAuth, setFieldValue, values])

    const action = () => {
        setShowModal(true)
    }

    return (
        <>
            <InputAutocompleteBtn
                isClearable={true}
                tamanho={props.tamanho}
                label={props.label}
                name={props.name}
                type="select"
                acaoBtn={() => action()}
                isMulti={props.multiplo || false}
                placeholder={props.placeholder || props.label} obrigatorio={props.obrigatorio}
                onChange={option => setFieldValue(props.name, option)}
                defaultOptions={data.length > 0 ? data : true}
                loadOptions={promiseOptions}

                {...props} />
            {/* <ModalPadraoCadastro titulo={'Cadastro Grupo'} showModal={showModal} setShowModal={setShowModal}>
                <CadastroGrupoModal modal="true" setShow={setShowModal} setItemSelecionado={setItemSelecionado}></CadastroGrupoModal>
            </ModalPadraoCadastro> */}
        </>
    )
}

const InputMunicipio = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrarMunicipios = inputValue => {
        let dataMunicipio = ls.get('dataMunicipio')
        if (dataMunicipio) {
            return dataMunicipio.filter(i =>
                removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase()))
            ).slice(0, 10)
        }
    }

    const carregarMunicipios = async (inputValue, callback) => {
        let dataMunicipio = ls.get('dataMunicipio')
        if (!dataMunicipio) {
            dataMunicipio = await getApiSetLocalStorage('dataMunicipio', '/parametros/combo/municipio')
        }

        if (inputValue.toString().length > 0)
            return callback(filtrarMunicipios(inputValue))

        return dataMunicipio.slice(0, 10)
    }

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            placeholder={props.placeholder}
            obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={carregarMunicipios}

            {...props} />)
}

const InputEstadoCivil = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/estadoCivil', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputBeneficiarioTitular = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/beneficiarioTitular', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputBeneficiario = ({ acaoBtn, iconeBtn, ...props }) => {
    const { setFieldValue, values } = useFormikContext();
    const [showModal, setShowModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)

    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/beneficiario', { pesquisa: inputValue }, null, null)).then(value => value)

    useEffect(() => {
        if (itemSelecionado != null) {
            if (props.multiplo) {
                const array = values[props.name] || []
                array.push(itemSelecionado)
                setFieldValue(props.name, [...array])
                if (props.onChangeOption)
                    props.onChangeOption([...array])
            } else {
                setFieldValue(props.name, itemSelecionado)
                if (props.onChangeOption)
                    props.onChangeOption(itemSelecionado)
            }
        }
    }, [itemSelecionado])

    const acao = () => {
        if (acaoBtn) {
            acaoBtn();
        } else {
            setShowModal(true);
        }
    }

    return (
        <>
            <InputAutocompleteBtn
                propsFormik={props.propsFormik}
                isClearable={true}
                tamanho={props.tamanho}
                label={props.label}
                name={props.name}
                type="select"
                isMulti={props.multiplo || false}
                botaoVisivel={props.botaoVisivel}
                placeholder={props.placeholder} obrigatorio={props.obrigatorio}
                iconeBtn={iconeBtn}
                onChange={option => {
                    if (props.onChangeOption)
                        props.onChangeOption(option);

                    setFieldValue(props.name, option)
                }}
                loadOptions={promiseOptions} acaoBtn={() => acao()} setReference={props.setReference ? props.setReference : {}}
                {...props} />
            <ModalPadraoCadastroCentral titulo={'Cadastro Paciente'} showModal={showModal} setShowModal={setShowModal}>
                <CadastroPaciente modal={true} setShow={setShowModal} setItemSelecionado={setItemSelecionado}></CadastroPaciente>
            </ModalPadraoCadastroCentral>
        </>
    )
}


const InputAgendaPaciente = ({ acaoBtn, iconeBtn, ...props }) => {
    const { setFieldValue, values } = useFormikContext();
    const [showModal, setShowModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)

    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/agendapaciente', { pesquisa: inputValue, prestador: getUsuario() }, null, null)).then(value => filtrar(value, inputValue))

    useEffect(() => {
        if (itemSelecionado != null) {
            if (props.multiplo) {
                const array = values[props.name] || []
                array.push(itemSelecionado)
                setFieldValue(props.name, [...array])
                if (props.onChangeOption)
                    props.onChangeOption([...array])
            } else {
                setFieldValue(props.name, itemSelecionado)
                if (props.onChangeOption)
                    props.onChangeOption(itemSelecionado)
            }
        }
    }, [itemSelecionado])

    const acao = () => {
        if (acaoBtn) {
            acaoBtn();
        } else {
            setShowModal(true);
        }
    }

    return (
        <>
            <InputAutocompleteBtn
                propsFormik={props.propsFormik}
                isClearable={true}
                tamanho={props.tamanho}
                label={props.label}
                name={props.name}
                type="select"
                isMulti={props.multiplo || false}
                botaoVisivel={props.botaoVisivel}
                placeholder={props.placeholder} obrigatorio={props.obrigatorio}
                iconeBtn={iconeBtn}
                onChange={option => {
                    if (props.onChangeOption)
                        props.onChangeOption(option);

                    setFieldValue(props.name, option)
                }}
                loadOptions={promiseOptions} acaoBtn={() => acao()} setReference={props.setReference ? props.setReference : {}} />
            <ModalPadraoCadastroCentral titulo={'Cadastro Paciente'} showModal={showModal} setShowModal={setShowModal}>
                <CadastroPaciente modal={true} setShow={setShowModal} setItemSelecionado={setItemSelecionado}></CadastroPaciente>
            </ModalPadraoCadastroCentral>
        </>
    )
}

const InputGrauDependencia = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/graudependencia', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputEmpresaParceira = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/empresaParceira', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputSexo = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/sexo', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputRaca = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/raca', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputEstado = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/estado', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputGrauInstrucao = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/grauinstrucao', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputPais = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/pais', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputAtividadeEconomica = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/atividadeeconomica', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputPessoaJuridicaTipo = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/pessoajuridicatipo', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => setFieldValue(props.name, option)}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputTipoPessoa = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/tipopessoa', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}

            {...props} />
    )
}

const InputStatusAgenda = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/agendastatus', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputCooperadoPF = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/cooperadopf', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocompleteBtn
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputCooperadoPJ = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/cooperadopj', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocompleteBtn
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputCBOS = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/cbos', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputPrestador = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/prestador', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    const Option = (props) => {
        const item = props.data
        return (
            <div>
                <components.Option {...props}>
                    {item.cpf_cnpj ? <>
                        <span style={{ fontSize: 11, fontWeight: '500', color: props.isSelected ? '#fff' : '#555' }}>{item.cpf_cnpj ? `CPF/CNPJ: ${item.cpf_cnpj} ` : ''}
                        </span>
                        <br />
                    </>
                        : <></>}
                    <span>{item.label}</span>
                </components.Option>
            </div>
        )
    }

    return (
        <InputAutocomplete
            components={{ Option }}
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            {...props}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
        />
    )
}

const InputConselhoProfissional = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/conselhoprofissional', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputSituacaoAdministrativa = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/situacaoadministrativa', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
            {...props} />
    )
}

const InputCooperadoPFPJ = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/cooperadopfpj', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            {...props}
            onChange={option => {
                setFieldValue(props.name, option)
                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
        />
    )
}

const InputTipoUsuario = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/controleAcesso/usuarioTipoCombo', null, null, null)).then(value => filtrar(value, inputValue))

    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder || props.label} obrigatorio={props.obrigatorio}
            loadOptions={promiseOptions}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            {...props} />
    )
}

const InputPrestadorEspecialidade = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);
    const [prestador, setPrestador] = useState(false);

    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(data).then(value => filtrar(value, inputValue))

    const forcarAtualizacao = (obj) => {
        if (prestador !== props.prestador?.value) {
            setData([])
            setLoading(true)
            get('/parametros/combo/prestadorcbos', { pesquisa: '', prestador: props.prestador }, null, null).then(value => {
                setPrestador(props.prestador?.value)
                setLoading(false)
                setData(value)
            })
        }
    }


    return (
        <InputAutocomplete
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            {...props}
            onChange={option => {
                setFieldValue(props.name, option)
                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
            cacheOptions={false}

            defaultOptions={data && data.length ? data : true}
            onMenuOpen={forcarAtualizacao}
            isLoading={loading}
        />
    )
}


const InputPrestadorConselho = (props) => {
    const { setFieldValue, values } = useFormikContext();
    const filtrar = (value, inputValue) => value.filter(i => removeAcentos((i.label || '').toLowerCase()).includes(removeAcentos(inputValue.toLowerCase())))

    const promiseOptions = inputValue => Promise.resolve(get('/parametros/combo/prestadorconselho', { pesquisa: inputValue }, null, null)).then(value => filtrar(value, inputValue))

    const Option = (props) => {
        const item = props.data
        return (
            <div>
                <components.Option {...props}>
                    {item.conselho ?
                        <span style={{ fontSize: 11, fontWeight: '500', color: props.isSelected ? '#000' : '#555', marginRight: 5, backgroundColor: '#cfe6d3', padding: '2px 5px 0px 5px', borderRadius: 5 }}>{item.conselho}</span>
                        : <></>}
                    {item.cpf_cnpj ? <>
                        <span style={{ fontSize: 11, fontWeight: '500', color: props.isSelected ? '#fff' : '#555' }}>{item.cpf_cnpj ? `CPF/CNPJ: ${item.cpf_cnpj} ` : ''}
                        </span>
                        <br />
                    </>
                        : <></>}
                    <span>{item.label}</span>
                </components.Option>
            </div>
        )
    }
    return (
        <InputAutocomplete
            components={{ Option }}
            isClearable={true}
            tamanho={props.tamanho}
            label={props.label}
            name={props.name}
            type="select"
            isMulti={props.multiplo || false}
            placeholder={props.placeholder} obrigatorio={props.obrigatorio}
            onChange={option => {
                setFieldValue(props.name, option)

                if (props.onChangeOption)
                    props.onChangeOption(option);
            }}
            loadOptions={promiseOptions}
            {...props}
        />
    )
}

export {
    InputEstadoCivil,
    InputEstado,
    InputSexo,
    InputMunicipio,
    InputSimNao,
    InputPais,
    InputOperadoraSaude,
    InputPorArray,
    InputGrupo,
    InputBeneficiarioTitular,
    InputBeneficiario,
    InputGrauDependencia,
    InputEmpresaParceira,
    InputRaca,
    InputGrauInstrucao,
    InputAtividadeEconomica,
    InputPessoaJuridicaTipo,
    InputTipoPessoa,
    InputCooperadoPF,
    InputCooperadoPJ,
    InputStatusAgenda,
    InputCBOS,
    InputConselhoProfissional,
    InputSituacaoAdministrativa,
    InputCooperadoPFPJ,
    InputTipoUsuario,
    InputPrestador,
    InputPrestadorEspecialidade,
    InputPrestadorConselho,
    InputAgendaPaciente
}